import script from "./ModuleDataValues.vue?vue&type=script&setup=true&lang=ts"
export * from "./ModuleDataValues.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__